
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class UsersMosaicView extends Vue {
    @Prop({default: false})
    public loading: boolean;

    @Prop({default: []})
    public usersGroups: any;

    get totalGroups(): number {
        return this.usersGroups.length;
    }

    private clickItem(group) {
        this.$emit("click-item", group);
    }
}
